<script setup>
import {getCurrentInstance} from 'vue'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String
})

const {proxy} = getCurrentInstance()
const store = proxy.$store

const openAddPaymentModal = () => {
    store.dispatch('modals/show', {
        componentName: 'OdpAddPaymentModal',
        obj: {
            bookingFormId: props.formId,
        }
    })
}

const openPaymentLogModal = () => {
    store.dispatch('modals/show', {
        componentName: 'OdpPaymentLogModal',
        obj: {
            bookingId: props.currentData.id,
        }
    })
}
</script>

<template>
    <div class="d-flex align-items-center mt-1">
        <span v-if="currentData.amountPaid" class="fs-6 me-2">£{{ currentData.amountPaid }}</span>

        <button :disabled="!currentData.id" class="btn btn-light btn-sm me-2" type="button"
                @click="openAddPaymentModal">
            Add payment
        </button>

        <button class="btn btn-light btn-sm" type="button" @click.prevent="openPaymentLogModal">
            Open payment log
        </button>
    </div>
</template>